import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Fonts_Pairings = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🎨 CSS Fonts Pairings</h1>

      {/* Intro Box */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #bbf7d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#166534", marginBottom: "0.5rem" }}>
          ✨ What is Font Pairing?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          Font pairing means using two (or more) fonts that look good together —
          usually one for headings and another for body text. The goal is to
          create contrast while keeping the design readable and attractive.
        </p>
      </div>

      {/* Explanation */}
      <div className="tutorial-section">
        <h2 className="section-title">📖 Popular Font Pairings</h2>
        <ul className="tutorial-list">
          <li>
            <strong>Roboto (body)</strong> +{" "}
            <strong>Montserrat (headings)</strong>
          </li>
          <li>
            <strong>Open Sans (body)</strong> + <strong>Lora (headings)</strong>
          </li>
          <li>
            <strong>Merriweather (body)</strong> +{" "}
            <strong>Oswald (headings)</strong>
          </li>
          <li>
            <strong>Nunito (body)</strong> + <strong>Poppins (headings)</strong>
          </li>
        </ul>
      </div>

      {/* Example Code */}
      <div className="tutorial-section">
        <h2 className="section-title">👨‍💻 Example: Roboto + Montserrat</h2>
        <CodeCopyBlock
          code={`<!-- In your HTML head -->
<link href="https://fonts.googleapis.com/css2?family=Roboto&family=Montserrat:wght@700&display=swap" rel="stylesheet">

<style>
  h1 {
    font-family: 'Montserrat', sans-serif;
  }
  p {
    font-family: 'Roboto', sans-serif;
  }
</style>`}
        />

        {/* Live Preview */}
        <h1 style={{ fontFamily: "'Montserrat', sans-serif" }}>
          Heading with Montserrat
        </h1>
        <p style={{ fontFamily: "'Roboto', sans-serif" }}>
          This is body text with Roboto. Clean and easy to read.
        </p>
      </div>

      {/* Best Practices */}
      <div className="tutorial-section">
        <h2 className="section-title">💡 Tips for Good Font Pairing</h2>
        <ul className="tutorial-list">
          <li>
            Use contrast: Pair a decorative heading font with a simple, readable
            body font.
          </li>
          <li>Avoid using too many fonts — 2 is usually enough.</li>
          <li>
            Make sure fonts match the mood of your website (professional,
            playful, elegant).
          </li>
          <li>
            Always include fallback fonts (like <code>sans-serif</code>,{" "}
            <code>serif</code>).
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          After learning about font pairings, explore{" "}
          <a href="/css/font-size" className="learn-more">
            CSS Font Size
          </a>{" "}
          and{" "}
          <a href="/css/font-weight" className="learn-more">
            CSS Font Weight
          </a>{" "}
          to style your chosen fonts more effectively.
        </p>
      </div>
    </div>
  );
};

export default Fonts_Pairings;
